import { BodyRegular, BodySmall } from '@src/fonts/typography/Typography';
import { DarkTextColor } from '@src/fonts/typography/TypographyColors';
import styled from 'styled-components';

export const VerificationFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const VerificationPersonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  &:not(:last-child) {
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 16px;
  }
`;

export const VerificationLoadingText = styled.p`
  ${BodySmall}
  ${DarkTextColor}
  text-align: center;
  margin: 0;
  padding: 20px;
`;

export const VerificationBinCodeHelperText = styled.p`
  ${BodyRegular}
  color: #666;
  margin: 0;
  font-style: italic;
  background-color: #e8e8e8;
  border-radius: 4px;
  padding: 8px;
`;
